import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from "@mui/icons-material/Menu";
import {
  Box,
  Button, DialogContent, TextField,
  Typography
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import * as React from 'react';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/images/VBM_LOGO_FULL.png";
import { useAppDispatch } from "../../hooks";
import { IApplication } from "../../interfaces/IApplication";
import { setPageTitle } from "../../slices/applicationSlice";
import ModuleMenu from '../../components/ModuleMenu';
import OrderSeedIcon from '@mui/icons-material/Assignment'
import SeedDemandIcon from '@mui/icons-material/FilterVintage'
import OrderIcon from '@mui/icons-material/ShoppingBasket';
import RecieveIcon from '@mui/icons-material/FileDownloadDone';
import ListIcon from '@mui/icons-material/List';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#666666' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  border: 0,
  borderRadius: 0,
  boxShadow: "none",
}));

const availableModules = [
  { label: "Patching", route: "/patching/dashboard" },
  { label: "Space Allocation", route: "/main/spaceallocationdashboard" },
  { label: "Tray Import", route: "/main/trayimportdashboard" },
  { label: "User Management", route: "/hr/usersdashboard" },
  { label: "Inventory", route: "/main/inventorydashboard" },
  { label: "Growing", route: "/main/growingdashboard" },
  { label: "Logistics", route: "/logistics/dashboard" },
  { label: "Invoicing", route: "/invoicing/dashboard" },
  { label: "Shipping", route: "/shipping/dashboard" },
  { label: "Purchase Orders", route: "/po/podashboard" },
];

export default function SeedingDashboard() {

  const dispatch = useAppDispatch();

  useEffect(() => {
    let appState: IApplication = {
      pageTitle: "Seeding Dashboard",
      backgroundPath: "/assets/images/growing.jpg"
    }
    dispatch(setPageTitle(appState));
  }, []);

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };


  const [errorMessage, setErrorMessage] = useState({ error: "" });
  const [value, setValue] = React.useState<any | null>(availableModules[0]);
  let items = [];
  let history = useNavigate();

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#999" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));


  const moduleChanged = (event: any, newValue: any | null) => {
    console.log(newValue);
    navigate(newValue.route);
  };

  const navigate = useNavigate();

  return (
    <div className="wrapper">
      <section className="loginArea">
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          paddingTop={5}
        >
          <img src={Logo} height="125px" />
        </Box>
        <Box display="flex"
          justifyContent="center"
          alignItems="center"
          marginTop={6}><Typography variant="h3">Seeding Dashboard</Typography>
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          marginTop={4}
          marginBottom={8}
        >
          <Paper
            component="form"
            sx={{
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: 700,
              boxShadow: 12,
            }}
          >
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={availableModules}
              sx={{ width: "100%" }}
              renderInput={(params) => <TextField {...params} label="Select a Module" />}
              onChange={(e, newValue) => { moduleChanged(e, newValue) }}
            />
            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <IconButton sx={{ p: "10px" }} aria-label="menu" onClick={handleClickOpen}>
              <MenuIcon />
            </IconButton>
          </Paper>
        </Box>

        <Box sx={{ flexGrow: 1, mt: 3 }}>
          <Grid container spacing={1} sx={{ padding: 2 }}>
            <Grid item xs={12} md={3}>
              <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                <Button
                  sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<SeedDemandIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                  onClick={() => navigate("/seeding/demand")}
                >
                  <Typography variant="h5" fontWeight="700">SEED DEMAND</Typography>
                </Button>
              </Item>
            </Grid>
            <Grid item xs={12} md={3}>
              <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                <Button
                  sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<OrderIcon sx={{ width: 45, height: 45, color: "#89B219" }} />}
                  onClick={() => navigate("/seeding/order")}
                >
                  <Typography variant="h5" fontWeight="700">ORDER SEED</Typography>
                </Button>
              </Item>
            </Grid>
            <Grid item xs={12} md={3}>
            <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                <Button
                  sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<RecieveIcon sx={{ width: 45, height: 45, color: "#89B219" }} />}
                  onClick={() => navigate("/seeding/receiving")}
                >
                  <Typography variant="h5" fontWeight="700">SEED RECEIVING</Typography>
                </Button>
              </Item>
            </Grid>
            <Grid item xs={12} md={3}>
            <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                <Button
                  sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<ListIcon sx={{ width: 45, height: 45, color: "#89B219" }} />}
                  onClick={() => navigate("/seeding/inventory")}
                >
                  <Typography variant="h5" fontWeight="700">SEED INVENTORY</Typography>
                </Button>
              </Item>
            </Grid>
          </Grid>
        </Box>
      </section>

      <div>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          maxWidth='xl'
          fullWidth
        >
          <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
            VBM Modules
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <ModuleMenu></ModuleMenu>
          </DialogContent>
        </BootstrapDialog>
      </div>
    </div>
  );
}
